import {UserInterface} from '@core/model/user/user.interface';
import {Action, createReducer, on} from '@ngrx/store';
import {userListSuccess} from '@core/redux/core.actions';

export interface CoreState {
  users: Array<UserInterface>;
}

export const initialState: CoreState = {
  users: null
};
const coreReducer = createReducer(
  initialState,
  on(userListSuccess, (state, { users }) => ({ ...state, users: users }))
)
export function reducer(state: CoreState, action: Action) {
  return coreReducer(state, action);
}
